import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function AboutGallery({ items }) {
  const [open, setOpen] = useState(null);
  if (!items?.length) return null;
  return (
    <div data-testid="sobremi-gallery" className="mt-20">
      <p className="overline mb-6">Galería</p>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {items.map((g, i) => (
          <button key={g.id} data-testid={`sobremi-gallery-item-${i}`} onClick={() => setOpen(g)}
            className="group overflow-hidden border border-white/5 hover:border-[#C9A25E]/40 transition-colors">
            <img src={`${BACKEND_URL}${g.url}`} alt="" loading="lazy"
              className="w-full aspect-square object-cover transition-transform duration-700 group-hover:scale-105" />
          </button>
        ))}
      </div>
      <Dialog open={!!open} onOpenChange={(v) => !v && setOpen(null)}>
        <DialogContent data-testid="sobremi-lightbox" className="max-w-5xl bg-[#06060C] border-[#C9A25E]/30 p-2">
          <DialogTitle className="sr-only">Foto</DialogTitle>
          {open && <img src={`${BACKEND_URL}${open.url}`} alt="" className="w-full max-h-[85vh] object-contain" />}
        </DialogContent>
      </Dialog>
    </div>
  );
}
